<div class="container">
  <div class="blue-line">
    <div class="calendar-top">
      <mat-icon>arrow_back</mat-icon>
      <span class="month">May</span>
    </div>
  </div>
  <div class="grey-line">
    <div class="row-days">
      <app-cell *ngFor="let step of [].constructor(7); let i = index" [text]="days[i]"></app-cell>
    </div>
  </div>

  <div class="row" *ngFor="let step of [].constructor(5)">
    <app-cell *ngFor="let step of [].constructor(7)"></app-cell>
  </div>
</div>
